import React from 'react';
// import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
// import { includes } from 'lodash';
import styled from 'styled-components';
// import { ProductType } from 'types';
import { CaseStudyCard } from 'components/shared';
import { theme, media } from 'styles';

const Wrapper = styled(FlipMove)`
  ${media.tablet`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  `};
`;

const CardWrapper = styled.div`
  margin-bottom: ${theme.sp.max};

  ${media.tablet`
    width: calc((100% - ${parseInt(theme.sp.xl, 10)}px) / 2);
  `};
`;

const propTypes = {
  // products: PropTypes.arrayOf(ProductType).isRequired,
  // selectedCategoryId: PropTypes.string,
};

const defaultProps = {
  // selectedCategoryId: undefined,
};

function List(props) {
  return (
    <Wrapper>
      {props.caseStudies.map(caseStudy => (
        <CardWrapper key={caseStudy.id}>
          <CaseStudyCard caseStudy={caseStudy} />
        </CardWrapper>
      ))}
    </Wrapper>
  );
}

// List.propTypes = propTypes;
// List.defaultProps = defaultProps;

export default List;



// WEBPACK FOOTER //
// ./src/components/CaseStudiesPage/components/List/List.jsx